module.exports = __webpack_public_path__ + "static/media/facebook-icon.bb26dbbb.svg";